import { render, staticRenderFns } from "./puErStaticsSuper.vue?vue&type=template&id=28f51670&scoped=true"
import script from "./puErStaticsSuper.vue?vue&type=script&lang=js"
export * from "./puErStaticsSuper.vue?vue&type=script&lang=js"
import style0 from "./puErStaticsSuper.vue?vue&type=style&index=0&id=28f51670&prod&lang=scss&scoped=true"
import style1 from "./puErStaticsSuper.vue?vue&type=style&index=1&id=28f51670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f51670",
  null
  
)

export default component.exports